import { useCurrencyIcons as useCurrencyIconsNative } from '@libs/components';

import { useAssets } from './useAssets';

export const useCurrencyIcons = (size = '3.1rem') => {
  const { assets } = useAssets();
  return useCurrencyIconsNative(size, assets.allAssets);
};
